// lib
import { connect } from "react-redux";
// src
import Component from "components/plannings/table/Table";
import { discardNetworkError } from "actions/system";

const mapStateToProps = ({
  presets: { isLight },
  system: { showNetworkError },
  table: { isLoadingInRange, notManagedByGeode, view },
  user: { identity},
  ux: { isLarge },
}) => ({
  identity,
  isLight,
  isLarge,
  isLoadingInRange,
  notManagedByGeode,
  showNetworkError,
  view,
});

const mapDispatchToProps = {
  discardNetworkError,
};

export default connect(mapStateToProps, mapDispatchToProps)(Component);
